import { render, staticRenderFns } from "./VxDateRangeDropdown.vue?vue&type=template&id=70ad4e0a&scoped=true"
import script from "./VxDateRangeDropdown.vue?vue&type=script&lang=js"
export * from "./VxDateRangeDropdown.vue?vue&type=script&lang=js"
import style0 from "./VxDateRangeDropdown.vue?vue&type=style&index=0&id=70ad4e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad4e0a",
  null
  
)

export default component.exports